import ILayerDashboardAttributeModel from '../model/ILayerDashboardAttributeModel';

export function sortAttributesToPlot(attributes: ILayerDashboardAttributeModel[]){
    const attributesFiltered = attributes.filter(x=>x.IsDataToPlot);

    attributesFiltered.sort((a, b) => a.Label.localeCompare(b.Label));

    return attributesFiltered;
}

export function sortAttributesToFilter(attributes: ILayerDashboardAttributeModel[]){
    const attributesFiltered = attributes.filter(x=>x.IsToFilter);

    attributesFiltered.sort((a, b) => a.Label.localeCompare(b.Label));

    return attributesFiltered;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLabel(attributes: string[], data: any) {
    let label = '';
    for (let attribute of attributes){
        if (!data[attribute]){
            continue;
        }

        if (label){
            label += ', ';
        }

        label += data[attribute];
    }

    if (!label){
        label = '-';
    }
    return label;
}